module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-right/direction-right.svg";